/* DEBUG */
const LOG = {
  LEVEL: 'WARN',
  ALL: ['assert','clear','count','countReset','debug','dir','dirxml','error','exception','group','groupCollapsed','groupEnd','info','log','profile','profileEnd','table','time','timeEnd','timeLog','timeStamp','trace','warn'],
  DEBUG: ['debug','clear','count','countReset','dir','dirxml','group','groupCollapsed','groupEnd','profile','profileEnd','table','time','timeEnd','timeLog','timeStamp','trace'],
  LOG: ['debug','log','clear','count','countReset','dir','dirxml','group','groupCollapsed','groupEnd','profile','profileEnd','table','time','timeEnd','timeLog','timeStamp','trace'],
  INFO: ['debug','log','info','clear','count','countReset','dir','dirxml','group','groupCollapsed','groupEnd','profile','profileEnd','table','time','timeEnd','timeLog','timeStamp','trace'],
  WARN: ['debug','log','info','clear','count','countReset','dir','dirxml','group','groupCollapsed','groupEnd','profile','profileEnd','table','time','timeEnd','timeLog','timeStamp','trace','warn'],
  style: {
    muted: "font-weight: 100; font-style: italic; color: #999",
    ok: "display:inline-block; padding-inline: 2px; background: #0f08; color: #fff",
    info:  "display:inline-block; padding-inline: 2px; background: #00f8; color: #fff",
    warning: "display:inline-block; padding-inline: 2px; background: #fc08; color: #fff",
  },
  element: function(el) {
    const id = el.id, claSS = el.getAttribute('class');
    return `{tag: ${el.tagName}` + 
      (id ? `, id: ${id}` : '') +
      (claSS ?  `, class: '${claSS}'` : '') +
      `}`
  }
}
window.LOG = LOG;
/* LOGGING LEVELS FROM FINEST TO OFF (From log4J)
ALL: The ALL has the lowest possible rank and is intended to turn on all logging.
<-- TRACE: The TRACE Level designates finer-grained informational events than the DEBUG. !HAS A DIFFERENT MEANING IN JS - Produces a stack trace -->
DEBUG: The DEBUG Level designates fine-grained informational events that are most useful to debug an application.
LOG: 
INFO: The INFO level designates informational messages that highlight the progress of the application at coarse-grained level.
WARN: The WARN level designates potentially harmful situations.
ERROR: The ERROR level designates error events that might still allow the application to continue running.
FATAL: The FATAL level designates very severe error events that will presumably lead the application to abort.
OFF: The OFF has the highest possible rank and is intended to turn off logging.
*/
console.info(`[LOAD] scripts/utils/debug.js LEVEL:${LOG.LEVEL}`)
if (LOG.LEVEL != "ALL") {
  LOG.ALL.forEach(method => {
    if(!LOG[LOG.LEVEL].includes(method)) {
      window.console[method] = function(){};
      window.console[method].trace = function(){};
    } else {
      window.console[method].dir = function(obj) {
        return console.dir(obj);
      }
      window.console[method].table = function(obj) {
        return console.table(obj);
      }
      window.console[method].trace = function() {
        return console.trace();
      }
    }
  })
}

window.console
/**/
console.groupCollapsed("LOG LEVELS")
  console.debug('[DEBUG]')
  console.log('[LOG]')
  console.info('[INFO]')
  console.warn('[WARN]')
  console.error('[ERROR]')
console.groupEnd()
